import gql from "graphql-tag";

export default gql`
	mutation deleteRole($role_id: ID!) {
		deleteRole(roleId: $role_id) {
			id
		}
	}
`;
